/*
 * @Author: Zhouqi
 * @Date: 2026-03-30 16:16:02
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-30 16:34:12
 */
import Image from 'next/image';

import { t } from '@/utils/helper/intl';

import styles from './style.module.scss';

const MobileInterceptPage: React.FC = () => {
  return (
    <div className={styles.container}>
      {/* 背景渐变蒙层 */}
      <div className={styles.bgOverlay} />

      {/* 笔记本电脑图 */}
      <div className={styles.laptopWrap}>
        <Image
          src="/images/mobile-guide-laptop.png"
          alt="FalcoCut PC"
          width={744}
          height={489}
          priority
          className={styles.laptopImg}
        />
      </div>

      {/* 底部文字 */}
      <div className={styles.textWrap}>
        <p className={styles.urlText}>{location.href}</p>
        <p className={styles.descText}>{t('mobile.intercept.desc')}</p>
      </div>
    </div>
  );
};

export default MobileInterceptPage;
